import i18n from '@/lib/i18n/i18n';
import { formatAddress } from '@/lib/utils/address';

import type { RiskObjectGroups, ROResidenceMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROResidenceMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_RESIDENCE_NAME',
        getValue: (residence) => residence.name,
      },
      {
        label: 'RO_RESIDENCE_BUILDING_TYPE',
        getValue: (residence) =>
          residence.building_type &&
          i18n.t(`BUILDING_TYPE_${residence.building_type}`),
      },
      {
        label: 'RO_RESIDENCE_HOUSE_TYPE',
        getValue: (residence) =>
          residence.attachment && i18n.t(`ATTACHMENT_${residence.attachment}`),
      },
      {
        label: 'RO_RESIDENCE_HOLDER_STATE',
        getValue: (residence) =>
          residence.holder_state &&
          i18n.t(`HOLDER_STATE_${residence.holder_state}`),
      },
      // {
      //   label: 'RO_RESIDENCE_IS_PRIMARY',
      //   getValue: (residence) => yesNo(residence.is_primary),
      // },
      // {
      //   label: 'RO_RESIDENCE_PURPOSE',
      //   getValue: (residence) =>
      //     residence.building_purpose &&
      //     i18n.t(`BUILDING_PURPOSE_${residence.building_purpose}`),
      // },
    ],
  },
  {
    title: 'RO_SECTION_ADDRESS',
    properties: [
      {
        label: 'RO_RESIDENCE_ADDRESS',
        getValue: (residence) => formatAddress(residence.address),
      },
    ],
  },
  {
    title: 'RO_SECTION_DIMENSIONS',
    properties: [
      // {
      //   label: 'RO_RESIDENCE_SURFACE',
      //   getValue: (residence) =>
      //     residence.main_building?.surface &&
      //     i18n.t(`${residence.main_building?.surface}m²`),
      // },
      // {
      //   label: 'RO_RESIDENCE_HABITABLE_SURFACE',
      //   getValue: (residence) =>
      //     residence.main_building?.habitable_surface &&
      //     i18n.t(`${residence.main_building?.habitable_surface}m²`),
      // },
      // {
      //   label: 'RO_RESIDENCE_HEIGHT',
      //   getValue: (residence) =>
      //     residence.main_building?.height &&
      //     i18n.t(`${residence.main_building?.height}m`),
      // },
      // {
      //   label: 'RO_RESIDENCE_FLOOR',
      //   getValue: (residence) => residence.main_building?.floor,
      // },
      // {
      //   label: 'RO_RESIDENCE_AGE',
      //   getValue: (residence) =>
      //     residence.main_building?.age &&
      //     i18n.t(`BUILDING_AGE_${residence.main_building.age}`),
      // },
      // {
      //   label: 'RO_RESIDENCE_BUILT_DATE',
      //   getValue: (residence) => toDateString(residence.built_date),
      // },
    ],
  },
  {
    title: 'RO_SECTION_CONSTRUCTION',
    properties: [
      // {
      //   label: 'RO_RESIDENCE_CONSTRUCTION_TYPE',
      //   getValue: (residence) =>
      //     residence.main_building?.construction_type &&
      //     i18n.t(
      //       `CONSTRUCTION_TYPE_${residence.main_building?.construction_type}`,
      //     ),
      // },
      // {
      //   label: 'RO_RESIDENCE_ROOF_TYPE',
      //   getValue: (residence) =>
      //     residence.main_building?.roof_construction_type &&
      //     i18n.t(
      //       `ROOF_TYPE_${residence.main_building?.roof_construction_type}`,
      //     ),
      // },
      // {
      //   label: 'RO_RESIDENCE_UNDER_CONSTRUCTION',
      //   getValue: (residence) =>
      //     yesNo(residence.main_building?.is_under_construction),
      // },
      // {
      //   label: 'RO_RESIDENCE_RECENTLY_RENOVATED',
      //   getValue: (residence) =>
      //     yesNo(
      //       typeof residence.main_building?.was_recently_renovated === 'number',
      //     ),
      // },
      // {
      //   label: 'RO_RESIDENCE_PASSIVE_HOUSE',
      //   getValue: (residence) =>
      //     yesNo(residence.main_building?.is_passive_house),
      // },
    ],
  },
  {
    title: 'RO_SECTION_VALUE',
    properties: [
      // {
      //   label: 'RO_RESIDENCE_RECONSTRUCTION_VALUE',
      //   getValue: (residence) =>
      //     formatCurrency(residence.main_building?.reconstruction_value),
      // },
      // {
      //   label: 'RO_RESIDENCE_CONTENT_VALUE',
      //   getValue: (residence) => formatCurrency(residence.content_value),
      // },
      // {
      //   label: 'RO_RESIDENCE_RENTAL_PRICE',
      //   getValue: (residence) => formatCurrency(residence.rental_price),
      // },
      // {
      //   label: 'RO_RESIDENCE_SOLAR_PANEL_VALUE',
      //   getValue: (residence) => formatCurrency(residence.solar_panel_value),
      // },
    ],
  },
  {
    title: 'RO_SECTION_FEATURES',
    properties: [
      // {
      //   label: 'RO_RESIDENCE_HAS_ATTIC',
      //   getValue: (residence) => yesNo(residence.main_building?.has_attic),
      // },
      // {
      //   label: 'RO_RESIDENCE_HAS_CELLAR',
      //   getValue: (residence) => yesNo(residence.main_building?.has_cellar),
      // },
      // {
      //   label: 'RO_RESIDENCE_HAS_GARDEN',
      //   getValue: (residence) => yesNo(residence.has_garden),
      // },
      // {
      //   label: 'RO_RESIDENCE_HAS_SOLAR_PANELS',
      //   getValue: (residence) => yesNo(residence.has_solar_panels),
      // },
      // {
      //   label: 'RO_RESIDENCE_HAS_POOL',
      //   getValue: (residence) => yesNo(residence.has_outside_swimming_pool),
      // },
      // {
      //   label: 'RO_RESIDENCE_HAS_ELEVATOR',
      //   getValue: (residence) => yesNo(residence.main_building?.has_elevator),
      // },
      // {
      //   label: 'RO_RESIDENCE_HAS_FIREPLACE',
      //   getValue: (residence) => yesNo(residence.has_fireplace),
      // },
      // {
      //   label: 'RO_RESIDENCE_ALARM_SYSTEM',
      //   getValue: (residence) =>
      //     residence.alarm_system && i18n.t(`ALARM_${residence.alarm_system}`),
      // },
    ],
  },
];

export default GROUPS;
